import React from 'react';
import { motion } from 'framer-motion';
import { Star, Award, BadgeCheck } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const miniTestimonials = [{
  quote: 'Sus manos son oro puro.',
  author: 'Angela B.'
}, {
  quote: 'Tan delicada que me quedé dormida.',
  author: 'Mel'
}, {
  quote: 'Excelente servicio, se nota el profesionalismo y experiencia.',
  author: 'Dennisse C.'
}];
export function AboutKate() {
  const {
    t
  } = useLanguage();
  return <section id="kate" className="py-12 md:py-24 bg-brand-white relative overflow-hidden" data-id="element-21">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="text-center mb-10 md:mb-16" data-id="element-23">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-24">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-25">
              {t('about.title1')}
              <br data-id="element-26" />
              <span className="block" data-id="element-27">{t('about.title2')}</span>
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-28"></div>
          </motion.div>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-29">
          {/* Image Column */}
          <motion.div className="w-full lg:w-1/2 flex justify-center" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-30">
            <div className="relative" data-id="element-31">
              {/* Decorative background elements */}
              <div className="absolute inset-0 bg-brand-gold/10 transform translate-x-4 translate-y-4 rounded-sm" data-id="element-32"></div>
              <div className="absolute inset-0 border border-brand-gold/30 transform -translate-x-4 -translate-y-4 rounded-sm" data-id="element-33"></div>

              <img src="https://cdn.magicpatterns.com/uploads/a88Vck385dy9wSQZE662vi/KATE_.png" alt="Kate - Fundadora de Tairu Aesthetics" className="relative z-10 w-full max-w-md object-cover rounded-sm shadow-xl" data-id="element-34" />

              {/* Review Badge */}
              <div className="absolute -bottom-6 -right-6 lg:-right-12 bg-white p-4 rounded-sm shadow-lg border border-brand-gold/20 z-20 flex items-center gap-3" data-id="element-35">
                <div className="bg-brand-gold/10 p-2 rounded-full" data-id="element-36">
                  <Award className="w-6 h-6 text-brand-gold" data-id="element-37" />
                </div>
                <div data-id="element-38">
                  <div className="flex text-brand-gold mb-1" data-id="element-39">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-40" />)}
                  </div>
                  <p className="text-xs font-bold text-brand-charcoal" data-id="element-41">
                    {t('about.badge')}
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Copy Column */}
          <motion.div className="w-full lg:w-1/2 space-y-6 text-lg text-brand-charcoal" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-42">
            <p className="font-serif text-2xl text-brand-gold-light italic" data-id="element-43">
              {t('about.p1')}
            </p>

            <p data-id="element-44">{t('about.p2')}</p>

            <div className="flex items-start gap-3 bg-brand-cream p-4 rounded-sm border-l-4 border-brand-gold my-6" data-id="element-45">
              <BadgeCheck className="w-6 h-6 text-brand-gold flex-shrink-0 mt-1" data-id="element-46" />
              <p className="text-sm" data-id="element-47">
                {t('about.p3_1')}
                <strong className="text-brand-brown" data-id="element-48">
                  {t('about.p3_bold')}
                </strong>
                {t('about.p3_2')}
              </p>
            </div>

            <p data-id="element-49">{t('about.p4')}</p>

            <p className="font-medium text-brand-brown mt-8" data-id="element-50">{t('about.p5')}</p>

            {/* Mini Testimonials */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8" data-id="element-51">
              {miniTestimonials.map((test, idx) => <div key={idx} className="bg-white p-4 border border-brand-gold/10 rounded-sm shadow-sm text-center" data-id="element-52">
                  <div className="flex justify-center text-brand-gold mb-2" data-id="element-53">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-54" />)}
                  </div>
                  <p className="text-sm italic mb-2" data-id="element-55">"{test.quote}"</p>
                  <p className="text-xs font-bold text-brand-brown" data-id="element-56">
                    — {test.author}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}